import axios from '@/plugins/axios';

let pendingReadUpdate = Promise.resolve();

export default {
    setReadStatus(notificationIds, read) {
        // Preserve the student's click order when an earlier request is still pending.
        const request = pendingReadUpdate
            .catch(() => {})
            .then(async () => {
                const response = await axios.patch(
                    '/api/notifications/read-status',
                    { notification_ids: notificationIds, read },
                    { timeout: 10000, retry: false }
                );
                return response.data;
            });
        pendingReadUpdate = request;
        return request;
    },
};
